// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__JycUq","title":"ClientCherryInfo_title__--xpR","itemText":"ClientCherryInfo_itemText__2Cy32"};